/// <amd-module name="Search/Shared/Components/ResultsInfo/ResultsInfo.Props" />

import { CodeResult, SearchQuery } from "Search/LegacyWebApi/Contracts/Code";

export interface IResultsInfoProps {
    infoMessage: string;

    showFeedbackLink: boolean;

    mailToLink?: string;

    /**
    * Invoked upon link click
    */
    onFeedbackLinkInvoked?: () => void;
    
    stalenessMessage?: string;

    DataRefreshLinkInvoked?: (query: SearchQuery, result: CodeResult) => void;
}
